// const URL = "https://stage.myciright.com/Ciright";
//const URL = "http://localhost:8086/Ciright";
const URL = "https://www.myciright.com/Ciright";

const AppConfig = {
  API: {
    ENDPOINT: URL + "/api",
    USER_PROFILE:
      URL +
      "/ajaxCall-photo.htm?flag=employeePhoto&compress=0&colorCode=veuit&id=",

    //----- Local
    // SUBSCRIPTION_ID: 9329,
    // VERTICAL_ID: 18,
    // APP_ID: 2785,
    // SPHERE_TYPE_URL: "contact-us-main.htm",
    // SPHERE_TYPE_ID: 2,

    //----- Live
    SUBSCRIPTION_ID: 9329,
    VERTICAL_ID: 18,
    APP_ID: 2785,
    SPHERE_TYPE_URL: "contact-us-main.htm",
    SPHERE_TYPE_ID: 2,
  },
};

export default AppConfig;
